import { useMemo } from "react";
import { ActionCard } from "./ActionCard";
import { useComputedValues } from "@rapid/contexts/ComputedValuesContext";
import { twClassNames } from "@scripts/react/helpers/twClassNames";
import pluralize from "pluralize";

interface AnnotationSummaryActionCardProps {
    disabled?: boolean;
}

export const AnnotationSummaryActionCard = ({ disabled }: AnnotationSummaryActionCardProps) => {
    const { currentFrameUserAnnotations } = useComputedValues();

    const summary = useMemo(() => {
        const count = currentFrameUserAnnotations.length;
        const labelCounts = new Map<string, number>();

        for (const annotation of currentFrameUserAnnotations) {
            labelCounts.set(annotation.label, (labelCounts.get(annotation.label) || 0) + 1);
        }

        return { count, labelCounts };
    }, [currentFrameUserAnnotations]);

    const labelBreakdown = useMemo(() => {
        const entries = Array.from(summary.labelCounts.entries());
        if (entries.length === 0) return "No annotations on this image";
        return entries.map(([label, count]) => `${count} ${pluralize(label, count)}`).join(", ");
    }, [summary.labelCounts]);

    return (
        <ActionCard
            title="Your Annotations"
            icon="far fa-draw-square"
            disabled={disabled}
            expandedContent={
                <div className={twClassNames("px-5 py-3", disabled && "pointer-events-none")}>
                    <div className="flex items-center">
                        <span className="text-sm text-secondary">{labelBreakdown}</span>
                    </div>
                </div>
            }
        />
    );
};
